import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import BootstrapVue3 from 'bootstrap-vue-3';
import { Icon, addCollection } from '@iconify/vue';
import VueToast from 'vue-toast-notification';
import { useAuthStore } from '@/stores/auth.store';
import i18n from './i18n';

import jQuery from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-ui-dist/jquery-ui.css';
window.$ = window.jQuery = jQuery;

import * as d3 from 'd3';
window.d3 = d3;

import * as c3 from 'c3';
import 'c3/c3.css';
window.c3 = c3;

import Plotly from 'plotly.js-dist';
window.Plotly = Plotly;

import 'pivottable';
import 'pivottable/dist/pivot.css';
import 'pivottable/dist/c3_renderers';
import 'pivottable/dist/d3_renderers';
import 'pivottable/dist/plotly_renderers';

import '@/styles/styles.scss';
import 'boxicons/css/boxicons.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue-multiselect/dist/vue-multiselect.css';
import '@/styles/vue-flow/style.css';
import '@/styles/vue-flow/theme-default.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'vue3-treeselect/dist/vue3-treeselect.css';

import rivetIcons from '@iconify-json/rivet-icons/icons.json';
import mdiIcons from '@iconify-json/mdi/icons.json';
import bxsIcons from '@iconify-json/bxs/icons.json';
import bxIcons from '@iconify-json/bx/icons.json';
import icIcons from '@iconify-json/ic/icons.json';
import fluentIcons from '@iconify-json/fluent/icons.json';
import cuidaIcons from '@iconify-json/cuida/icons.json';
import ggIcons from '@iconify-json/gg/icons.json';
import uilIcons from '@iconify-json/uil/icons.json';
import fileIcons from '@iconify-json/file-icons/icons.json';
import lsiconIcons from '@iconify-json/lsicon/icons.json';
import materialSymbols from '@iconify-json/material-symbols/icons.json';
import gisIcons from '@iconify-json/gis/icons.json';
import flagpackIcons from '@iconify-json/flagpack/icons.json';

const pinia = createPinia();

pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

app.component('Icon', Icon);

addCollection(rivetIcons);
addCollection(mdiIcons);
addCollection(bxsIcons);
addCollection(bxIcons);
addCollection(icIcons);
addCollection(fluentIcons);
addCollection(cuidaIcons);
addCollection(ggIcons);
addCollection(uilIcons);
addCollection(fileIcons);
addCollection(lsiconIcons);
addCollection(materialSymbols);
addCollection(gisIcons);
addCollection(flagpackIcons);

app.use(VueToast, {
  position: 'bottom-right',
  duration: 5000,
});
app.use(pinia);
app.use(BootstrapVue3);
app.use(router);
app.use(i18n);

const authStore = useAuthStore();

authStore.checkAndInitializeFirebase();

app.mount('#app');
